import { Component } from '@angular/core';
import {EmpresaDetalhes} from "../../../models/empresa-detalhes";
import {EmpresaService} from "../../../services/empresa.service";
import {BaseResponse} from "../../../../../core/models/base-response";

@Component({
    selector: 'app-meu-plano',
    templateUrl: './meu-plano.component.html',
    styleUrl: './meu-plano.component.css',
    standalone: false
})
export class MeuPlanoComponent {
  empresaDetalhes = new EmpresaDetalhes();

  constructor(private empresaService: EmpresaService) {
    this.empresaService.buscarDetalhes().subscribe((response: BaseResponse<EmpresaDetalhes> | BaseResponse<any>) => {
      if (response.sucesso) {
        this.empresaDetalhes = response.dados;
      } else {
        // handle error
      }
    });
  }
}
